module.exports = __webpack_public_path__ + "static/media/img333.2705f282.jpg";